// Who sees the Marketing Tools section (nav + route). Server mirrors this in functions/marketing/templates.js.
import { normalizeRole } from './roles';
export const MARKETING_TOOL_ROLES = ['Admin', 'Marketing Manager'];
export const canUseMarketingTools = (role) => MARKETING_TOOL_ROLES.includes(normalizeRole(role));

// Tools the Marketing Manager role does not see (tile hidden and route blocked). Admins and agents unchanged.
export const MM_HIDDEN_TOOL_ROUTES = ['/tools/pocket-listings', '/tools/cma', '/tools/mortgage', '/tools/net-sheet'];
export const isToolHiddenForRole = (role, route) => normalizeRole(role) === 'Marketing Manager' && MM_HIDDEN_TOOL_ROUTES.includes(route);
